import React, { useRef, useState } from "react";
import DataGrid, { Column, FilterRow, HeaderFilter, Pager, Paging, SearchPanel, } from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { Card } from "react-bootstrap";

const ReturnToMayaveProduct = () => {
    const dataGridRef = useRef<any>(null);
    // const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
    const [pagination, setPagination] = useState({ pageSize: 10, pageNumber: 1 });

    const [dataGridFilter, setGridFilter] = useState<{
        showFilterRow: boolean;
        showHeaderFilter: boolean;
        currentFilter: 'auto' | 'onClick';
    }>({
        showFilterRow: true,
        showHeaderFilter: true,
        currentFilter: 'auto',
    });

    // useEffect(() => {
    //     const authUserString = localStorage.getItem("authPOSUser");
    //     if (authUserString) {
    //         const authUser = JSON.parse(authUserString);
    //         const permissionData = authUser?.permissions || [];
    //         setPermissionDetails(permissionData);
    //     }
    // }, []);

    // const HasPermission = (permission: string): boolean => {
    //     return permissionDetails.includes(permission);
    // };

    const dataSource = React.useMemo(() => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const searchValue = loadOptions.searchValue;
                    if (!searchValue || searchValue.length < 3) {
                        return { data: [], totalCount: 0 };
                    }
                    const params = new URLSearchParams();
                    params.set('skip', String(loadOptions.skip ?? 0));
                    params.set('take', String(loadOptions.take ?? 10));
                    if (searchValue) {
                        params.set('search', searchValue);
                    }
                    // const response = await getAllReturnToMayaveProduct(params);
                    // return {
                    //     data: response.data ?? [],
                    //     totalCount: response.totalCount ?? 0
                    // };
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    }, []);

    const onPagingChange = ({ pageSize, pageIndex, }: { pageSize?: number; pageIndex?: number; }) => {
        setPagination({
            pageSize: pageSize ?? pagination.pageSize,
            pageNumber: (pageIndex ?? pagination.pageNumber - 1) + 1,
        });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Return To Mayave Product</h5>

                        </Card.Header>
                        <Card.Body className="pt-0">
                            {/* {HasPermission("Customer.Read") ? ( */}
                            <DataGrid
                                ref={dataGridRef}
                                dataSource={dataSource}
                                remoteOperations={{ paging: true }}
                                onOptionChanged={(e) => {
                                    if (e.fullName === 'paging.pageIndex' || e.fullName === 'paging.pageSize') {
                                        onPagingChange({
                                            pageIndex: e.fullName === 'paging.pageIndex' ? e.value : pagination.pageNumber - 1,
                                            pageSize: e.fullName === 'paging.pageSize' ? e.value : pagination.pageSize,
                                        });
                                    }
                                }}
                                showRowLines={true}
                                keyExpr="id"
                                showBorders={true}
                                // onSelectionChanged={handleSelectionChange}
                                columnAutoWidth={true}
                            >
                                <Pager
                                    visible={true}
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />
                                <Paging pageSize={pagination?.pageSize} />
                                {/* <FilterRow visible={dataGridFilter?.showFilterRow} applyFilter={dataGridFilter?.currentFilter} />
                                <HeaderFilter visible={dataGridFilter?.showHeaderFilter} /> */}
                                <SearchPanel visible={true} width={240} placeholder="Search..." />


                                <Column
                                    caption="Sr.No."
                                    dataType="number"
                                    alignment="center"
                                    // width="15%"
                                    cellRender={(e) => {
                                        const rowIndex = e.rowIndex;
                                        const currentPage = pagination.pageNumber;
                                        const pageSize = pagination.pageSize;
                                        const serialNumber = (currentPage - 1) * pageSize + rowIndex + 1;
                                        return <span>{serialNumber}</span>;
                                    }}
                                />
                                <Column dataField="BagNo" caption="BagNo." dataType="string" />
                                <Column dataField="Category" caption="Category" dataType="number" />
                                <Column dataField="CertificateNo" caption="Certificate Number" dataType="string" />
                                <Column dataField="Cocd" caption="Co cd" dataType="string" />
                                <Column dataField="CollectionId" caption="Collection" dataType="number" />
                                <Column dataField="Color" caption="Color" dataType="string" />
                                <Column dataField="ColorStoneWt" caption="Color Stone Weight" dataType="number" />
                                <Column dataField="CustomerDiaVariantAmount" caption="Customer Diamond Variant Amount" dataType="string" />
                                <Column dataField="CustomerVariantGoldRate" caption="Customer Variant Gold Rate" dataType="string" />
                                <Column dataField="DiaQty" caption="Diamond Quality" dataType="string" />
                                <Column dataField="DiaMargin" caption="Diamond Margin" dataType="string" />
                                <Column dataField="DiaMrp" caption="Dia Mrp" dataType="string" />
                                <Column dataField="DPPrice" caption="Depository Participant Price" dataType="string" />
                                <Column dataField="FranchiseVariantGoldRate" caption="Franchise Variant Gold Rate" dataType="string" />
                                <Column dataField="FranchiseDiaVariantAmount" caption="Franchise Diamond Variant Amount" dataType="string" />
                                <Column dataField="FranchiseLaborVariantAmount" caption="Franchise Labor Variant Amount" dataType="string" />
                                <Column dataField="GrossWt" caption="Gross Weight" dataType="number" />
                                <Column dataField="GoldMrp" caption="Gold Mrp" dataType="string" />
                                <Column dataField="HUID" caption="Hallmark Unique Identification" dataType="string" />
                                <Column dataField="InvoiceNo" caption="Invoice No." dataType="string" />
                                <Column dataField="InvoiceDate" caption="Invoice Date" dataType="date" />
                                <Column dataField="InwardDate" caption="Inward Date" dataType="date" />
                                <Column dataField="LaborMargin" caption="Labor Margin" dataType="string" />
                                <Column dataField="LabMrp" caption="Lab Mrp" dataType="string" />
                                <Column dataField="MaterialType" caption="Material Type " dataType="number" />
                                <Column dataField="MetalKT" caption="Metal KT" dataType="string" />
                                <Column dataField="MetalColor" caption="Metal Color" dataType="string" />
                                <Column dataField="Mrp" caption="Market Rate Price" dataType="string" />
                                <Column dataField="MRPPrice" caption="MRP Price" dataType="number" />
                                <Column dataField="NetWt" caption="Net Weight" dataType="number" />
                                <Column dataField="OdIdNo" caption="Od Id No" dataType="string" />
                                <Column dataField="OdSfx" caption="OdSfx" dataType="string" />
                                <Column dataField="OrdNo" caption="Order Number" dataType="string" />
                                <Column dataField="OrderTypeId" caption="Order Type" dataType="number" />
                                <Column dataField="OrderDate" caption="Order Date" dataType="date" />
                                <Column dataField="OldDP" caption="Old DP" dataType="string" />
                                <Column dataField="OldMrp" caption="Old Mrp" dataType="string" />
                                <Column dataField="OtherWt" caption="Other Weight" dataType="string" />
                                <Column dataField="OverallMargin" caption="Over All Margin" dataType="string" />
                                <Column dataField="Qty" caption="Quality" dataType="string" />
                                <Column dataField="Size" caption="Size" dataType="string" />
                                <Column dataField="StoreCode" caption="Store Code" dataType="string" />
                                <Column dataField="StyleNo" caption="Style Number" dataType="string" />
                                <Column dataField="IsActive" caption="Is Active" dataType="string" />
                                <Column dataField="IsReceived" caption="Is Received" dataType="string" />
                                <Column dataField="IsRepaired" caption="Is Repaired" dataType="string" />
                                <Column dataField="IsSNMCC" caption="Is SNMCC" dataType="string" />
                                <Column dataField="IsSpecial" caption="Is Special" dataType="string" />
                                <Column dataField="IsSRP" caption="Is SRP" dataType="string" />
                                <Column dataField="IsStoreReturn" caption="Is Store Return" dataType="string" />


                            </DataGrid>
                            {/* ) : ( */}
                            {/* <div className="text-center fs-5 fw-bold">
                                        <Result
                                            status="403"
                                            title="401"
                                            subTitle="Sorry, you are not authorized to access this data."
                                            className="custom-result"
                                        />
                                    </div>
                                )} */}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    );
}
export default ReturnToMayaveProduct;